import { useCallback, type FC, type MouseEvent } from 'react'

import { useTheme } from '@emotion/react'

import styled from '@emotion/styled'

import { Button } from '@segment/matcha/components/Button/Button'

import { trackButtonClick } from '@segment/tracking/scripts'

import { BackgroundImage, ButtonWrapper, Description, Modal, ModalBody, ModalHead } from './Modal.views'

import imageCtaWrapperPng from './assets/ImageCtaWrapper.png'

const copy = {
  description: `Explore this interactive demo to see how Segment helps teams collect, clean, and activate data.`,
  buttonText: `Start the tour`,
}

interface DesktopImageCtaProps {
  onClick: (event: MouseEvent<HTMLElement>) => void
}

export const DesktopImageCta: FC<DesktopImageCtaProps> = ({ onClick }) => {
  const theme = useTheme()
  const onClickHandler = useCallback(
    async (e: MouseEvent<HTMLElement>) => {
      await trackButtonClick({ buttonText: copy.buttonText, buttonId: `Product tour` })
      onClick(e)
    },
    [onClick]
  )
  return (
    <Wrapper>
      <BackgroundImage alt="" src={imageCtaWrapperPng} />
      <Modal
        role="dialog"
        elevation={1}
        maxWidth={360}
        backgroundColor={theme.palette.neutrals.white[100]}
        sectionSeparatorColor={theme.palette.neutrals.white[100]}
      >
        <ModalHead></ModalHead>
        <ModalBody>
          <Description variant="pSmall">{copy.description}</Description>
          <ButtonWrapper>
            <Button variant="filled" color="primary" size="large" onClick={onClickHandler}>
              {copy.buttonText}
            </Button>
          </ButtonWrapper>
        </ModalBody>
      </Modal>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
`
